import React from 'react';

import { DisplayButton } from 'components/buttons';

const ConfirmButton = () => (
  <DisplayButton text="Y" />
);

export default ConfirmButton;



// WEBPACK FOOTER //
// ./src/components/buttons/ConfirmButton/ConfirmButton.js